// RIBBON rowset registry — the Row 1 MORPH SLOT (R0, 2026-07-20).
//
// Row 1 renders "the words" for whatever is selected (CONCEPT-text-ribbon §1):
// a registered ROWSET per selection kind. Row 2 never morphs — it is a single
// rowset fetched by its own accessor so no caller can accidentally swap it.
//
// Pure module (a Map + accessors): node-loadable, no React, no live imports.
// The future mount (R1+) derives `kind` from its selection mirrors and calls
// getRow1Rowset(kind); adding a selection kind = registering a rowset,
// zero new architecture (the Subject-toolsets manifest philosophy).

/** @typedef {import('./types').Rowset} Rowset — see rowsets/textRow1.mjs for
 *  the authoritative shape documentation (groups + control descriptors). */

// 'icon' rides the image type (FabricImage + isIcon) but morphs its own row —
// registered by R2 alongside the honest shape/image/page sets.
export const SELECTION_KINDS = ['text', 'shape', 'image', 'icon', 'none'];

const row1sets = new Map();
let row2set = null;

/** Register Row 1's rowset for a selection kind ('text'|'shape'|'image'|'none'
 *  — 'none' is the page-tools row). Later registrations replace earlier ones
 *  (hot-reload friendly). */
export function registerRow1Rowset(kind, rowset) {
  if (!kind || typeof kind !== 'string') throw new Error('rowsetRegistry: kind required');
  if (!rowset || !Array.isArray(rowset.groups)) throw new Error(`rowsetRegistry: rowset for '${kind}' needs .groups[]`);
  row1sets.set(kind, rowset);
}

/** Row 1 rowset for a selection kind; unknown kinds fall back to 'none'
 *  (page tools) so the ribbon never renders empty. */
export function getRow1Rowset(kind) {
  return row1sets.get(kind) || row1sets.get('none') || EMPTY_ROWSET;
}

/** Register THE universal Row 2 rowset (one, forever — CONCEPT §1). */
export function registerRow2Rowset(rowset) {
  if (!rowset || !Array.isArray(rowset.groups)) throw new Error('rowsetRegistry: row 2 rowset needs .groups[]');
  row2set = rowset;
}

/** The universal Row 2 rowset (identical for every selection kind). */
export function getRow2Rowset() {
  return row2set || EMPTY_ROWSET;
}

export function getRegisteredKinds() {
  return [...row1sets.keys()];
}

const EMPTY_ROWSET = Object.freeze({ id: 'empty', groups: [] });
